import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    hoursWorkedList: () => {
        return HTTP.get('/workshift', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    addWorkShift: (data) => {
        return HTTP.post('/workshift/cretae',data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    editWorkShift: (id,data) => {
        return HTTP.post('/workshift/update/'+id,data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    detailWorkShift: (id) => {
        return HTTP.get('/workshift/edit/'+id, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}